import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { t } from 'translation'
import history from 'utils/appHistory'

import circleHead from '../assets/cirlce-head.png'
import backIcon from '../assets/back-icon.png'

import SettingsModal from 'components/SettingsModal/SettingsModal'

const MobileManage = (props) => {
  // toggleSettingsHandler = () => {
  //   this.setState((prevState) => ({
  //     areSettingsOpen: !prevState.areSettingsOpen,
  //   }))
  // }

  useEffect(() => {
    document.documentElement.classList.remove('no_scale_mod')
  }, [])

  return (
    <section className="section">
      {/* <SettingsModal
        toggleSettingsHandler={this.toggleSettingsHandler}
        areSettingsOpen={this.state.areSettingsOpen}
      /> */}
      <div className="subscribe_in">
        {((props.subscribed && !props.updatePayment && !props.isPro) || props.isPro) && (
          <img
            onClick={() => history.go('-1')}
            src={backIcon}
            className="subscribe_back"
            alt="back"
          />
        )}
        <img src={circleHead} className="subscribe_image" alt="login" />
        {((props.subscribed && !props.updatePayment && !props.isPro) || props.isPro) && (
          <div className="subscribe_title">{t('subscription.MANAGE_ACCOUNT')}</div>
        )}
        {!props.subscribed && !props.isPro && (
          <div className="subscribe_title">{t('subscription.MANAGE_SUBSCRIPTION')}</div>
        )}
        {props.updatePayment && !props.isPro && (
          <div className="subscribe_title">{t('subscription.MANAGE_PAYMENT')}</div>
        )}
        <div className="subscribe_descr">{t('subscription.MANAGE_GO_TO')}</div>
      </div>
    </section>
  )
}

const mapStateToProps = ({ auth: { attributes, isPro } }) => ({
  userCreatedDate: new Date(attributes.userCreatedDate),
  attributes,
  freeDays: attributes.licenses.freeDays,
  subscribed: JSON.parse(attributes?.subscribed || false),
  updatePayment: attributes.updatePayment,
  isPro,
})

export default connect(mapStateToProps)(MobileManage)
